import {
  BULK_DELETE,
  HOUSING_EXPENSES,
  HOUSING_DATABASES,
  HOUSING_EXPENSE_REJECTED,
  HOUSING_EXPENSE_APPROVAL,
} from "constants/endpoints";
import { deleteApi, get, post, put } from "services/network";
import CustomToast from "components/common/custom-toast";
import { toast } from "react-toastify";
import { alertTypes } from "constants/common";

const buildYesNoWithRangeFilter = (field) => {
  if (!field || field.checked === null || field.checked === undefined) {
    return { flag: "", range: "" };
  }

  return {
    flag: field.checked,
    range: field.subItem?.length
      ? field.subItem.map((item) => item.value).join(",")
      : "",
  };
};

export const getHousingDatabases = async (obj) => {
  const rent = obj.rent?.map((item) => item.value) || [];
  const income = obj.income?.map((item) => item.value) || [];

  const credit = buildYesNoWithRangeFilter(obj?.creditScore);
  const age = buildYesNoWithRangeFilter(obj?.ageRequirement);
  const deposit = buildYesNoWithRangeFilter(obj?.securityDeposit);
  const fee = buildYesNoWithRangeFilter(obj?.application_fee);

  const params = {
    page: obj?.page || 1,
    per: obj?.perPage || 10,
    query: obj?.search || "",
    sort: obj?.key || "",
    order: obj?.order || "",

    county: obj?.county?.value || "",
    state: obj?.state?.value || "",
    zipcode: obj?.zipcode?.value || "",
    distance: obj?.distance || "",

    rent: rent.length ? rent.join(",") : "",
    income: income.length ? income.join(",") : "",

    "filter[no_eviction]": obj?.noEviction ?? "",
    "filter[credit_check]": obj?.creditCheck ?? "",
    "filter[background]": obj?.background ?? "",
    "filter[rental_history]": obj?.rent_history ?? "",
    "filter[no_3rd_party_checks]": obj?.party_checks ?? "",
    "filter[no_bankruptcy]": obj?.no_bankrupty ?? "",

    "filter[credit_score]": credit.flag,
    "filter[credit_score_range]": credit.range,

    "filter[age_requirement]": age.flag,
    "filter[age_requirement_value]": age.range,

    "filter[security_deposit]": deposit.flag,
    "filter[security_deposit_amount]": deposit.range,

    "filter[application_fee]": fee.flag,
    "filter[application_fee_amount]": fee.range,
  };

  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== "" && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join("&");

  try {
    const result = await get(`${HOUSING_DATABASES}?${queryString}`, true);
    return result;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getHousingExpenseById = async (id) => {
  try {
    const result = await get(`${HOUSING_EXPENSES}/${id}`, true);
    return result;
  } catch (error) {
    console.log(error);
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
  }
};

export const getHousingExpense = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    per: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
    key: obj?.key ? obj.key : "",
    order: obj?.order ? obj.order : "",
    state: Array.isArray(obj?.state)
      ? obj.state.map((c) => c.value).join(",")
      : "",
    county: Array.isArray(obj?.county)
      ? obj.county.map((c) => c.value).join(",")
      : "",
    health_plan_id: obj.health_plan_id ? obj.health_plan_id : "",
    expense_request_status: obj.expense_request_status
      ? obj.expense_request_status
      : "",
  };
  try {
    const result = await get(
      `${HOUSING_EXPENSES}?page=${params.page}&per=${params.per}&query=${params.search}&sort=${params.key}&order=${params.order}&state_id=${params.state}&county_id=${params.county}&health_plan_id=${params.health_plan_id}&filter[status]=${params.expense_request_status}`,
      true,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createHousingDatabases = async (data, setErrors = () => {}) => {
  try {
    const result = await post(HOUSING_DATABASES, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Property created successfully"
      />,
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
    console.log(error);
  }
};

export const updateHousingDatabases = async (
  data,
  id,
  setErrors = () => {},
) => {
  try {
    const result = await put(`${HOUSING_DATABASES}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Property updated successfully"
      />,
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
    console.log(error);
  }
};

export const updateHousingExpense = async (data, id, setErrors = () => {}) => {
  try {
    const result = await put(`${HOUSING_EXPENSES}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Housing expense request updated successfully"
      />,
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data?.errors["base"]);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.data?.errors["base"]}
      />,
    );
    console.log(error);
  }
};

export const createHousingExpense = async (data, id, setErrors = () => {}) => {
  try {
    const result = await post(`${HOUSING_EXPENSES}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Housing expense request created successfully"
      />,
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data?.errors["base"]);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.data?.errors["base"]}
      />,
    );
    console.log(error);
  }
};

export const deleteHousingDatabases = async (id) => {
  try {
    const result = await deleteApi(`${HOUSING_DATABASES}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Property deleted successfully"
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "test"}
      />,
    );
    // console.log(result);
  }
};

export const deleteBulkHousingDatabases = async (data) => {
  try {
    const result = await put(`${HOUSING_DATABASES}/${BULK_DELETE}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Property deleted successfully"
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
  }
};

export const RejectedHousingExpense = async (id, data) => {
  try {
    const result = await put(HOUSING_EXPENSE_REJECTED(id), data, true);
    toast(
      <CustomToast
        variant={alertTypes.SUCCESS}
        message={"Housing Expense Rejected"}
      />,
    );
    return result;
  } catch (error) {
    console.log(error);
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
  }
};
export const ApprovedHousingExpense = async (id, data) => {
  try {
    const result = await put(HOUSING_EXPENSE_APPROVAL(id), data, true);
    toast(
      <CustomToast
        variant={alertTypes.SUCCESS}
        message={"Housing Expense Approved"}
      />,
    );
    return result;
  } catch (error) {
    console.log(error);
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.data?.errors[0]?.message || error?.response?.statusText}
      />,
    );
  }
};
